import * as React from "react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import Item from "./Item";
import style from "./style.module.scss";
import {
  ChefIcon,
  MealIcon,
  MenuSearchLineIcon,
  PaymentIcon,
  ScanIcon,
  UserSettingsIcon,
  WalletIcon,
} from "../../assets/icons";
import { useLocation, useRoutes } from "react-router-dom";
import Can, { ListWrapRenderer } from "../Can";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

export default function LeftNav() {
  const [active, setActive] = React.useState("meal-planning");
  const { pathname } = useLocation();
  const permissions = useSelector((state: RootState) => state.user.permissions);

  return (
    <>
      <List
        sx={{ bgcolor: "background.paper", padding: "16px 24px 8px 24px" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader className={style.subheader} component="div">
            <MealIcon width={24} height={24} /> Meals & Plans
          </ListSubheader>
        }
        className={style.list}
      >
        <Can permission="MEAL_PLANNING_VIEW">
          <Item
            index={0}
            className={`${style.item} ${pathname === "/meal-planning" ? style.active : ""}`}
            text="Menu Planner"
            link="/meal-planning"
          />
        </Can>
        <Can permission="PLAN_VIEW">
          <Item
            index={1}
            className={`${style.item} ${pathname.includes("/plan") ? style.active : ""}`}
            text="Plans"
            link="/plan"
          />
        </Can>
        <Can permission="MEAL_VIEW">
          <Item
            index={2}
            className={`${style.item} ${pathname === "/meals" ? style.active : ""}`}
            text="Meals"
            link="/meals"
          />
        </Can>
      </List>

      <List
        sx={{ bgcolor: "background.paper", padding: "8px 24px" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader className={style.subheader} component="div">
            <UserSettingsIcon /> Subscription
          </ListSubheader>
        }
        className={style.list}
      >
        <Can permission="USER_VIEW">
          <Item
            index={0}
            className={`${style.item} ${pathname.startsWith("/users") ? style.active : ""}`}
            text="Users"
            link="/users"
          />
        </Can>
      </List>

      <List
        sx={{ bgcolor: "background.paper", padding: "8px 24px" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader className={style.subheader} component="div">
            <ChefIcon /> Kitchen
          </ListSubheader>
        }
        className={style.list}
      >
        <Can permission="REVIEW_VIEW">
          <Item
            index={0}
            className={`${style.item} ${pathname === "/review" ? style.active : null}`}
            text="Review"
            link="/review"
          />
        </Can>
        <Can permission="KITCHEN_REPORT_VIEW">
          <Item
            index={1}
            className={`${style.item} ${pathname === "/kitchen/report" ? style.active : null}`}
            text="Kitchen Report"
            link="/kitchen/report"
          />
        </Can>
      </List>

      <List
        sx={{ bgcolor: "background.paper", padding: "8px 24px" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader className={style.subheader} component="div">
            <ScanIcon /> Delivery
          </ListSubheader>
        }
        className={style.list}
      >
        <Can permission="DRIVER_VIEW">
          <Item
            index={0}
            className={`${style.item} ${pathname.startsWith("/drivers") ? style.active : ""}`}
            text="Drivers"
            link="/drivers"
          />
        </Can>
        <Can permission="DELIVERY_REPORT_VIEW">
          <Item
            index={1}
            className={`${style.item} ${pathname === "/delivery/report" ? style.active : null}`}
            text="Delivery Report"
            link="/delivery/report"
          />
        </Can>
        {/* <Can permission="DELIVERY_REPORT_VIEW">
          <Item
            index={2}
            className={`${style.new} ${style.item} ${pathname.startsWith("/areas") ? style.active : ""}`}
            text="Areas"
            link="/areas"
          />
        </Can> */}
      </List>

      <List
        sx={{ bgcolor: "background.paper", padding: "8px 24px" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader className={style.subheader} component="div">
            <PaymentIcon /> Pricing
          </ListSubheader>
        }
        className={style.list}
      >
        <Can permission="DELIVERY_FEE_VIEW">
          <Item
            index={0}
            className={`${style.item} ${pathname === "/delivery/fee" ? style.active : null}`}
            text="Delivery Fee"
            link="/delivery/fee"
          />
        </Can>
        <Can permission="DISCOUNT_VIEW">
          <Item
            index={1}
            className={`${style.item} ${pathname === "/discount" ? style.active : null}`}
            text="Discount"
            link="/discount"
          />
        </Can>
      </List>

      <List
        sx={{ bgcolor: "background.paper", padding: "8px 24px" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader className={style.subheader} component="div">
            <WalletIcon /> Reports
          </ListSubheader>
        }
        className={style.list}
      >
        <Can permission="FINANCIAL_REPORT_VIEW">
          <Item
            index={0}
            className={`${style.item} ${pathname === "/financial/report" ? style.active : null}`}
            text="Financial Reports"
            link="/financial/report"
          />
        </Can>
      </List>
    </>
  );
}
